import http, { url } from '../../http'

const API_URL = "acpm-inv-matrix"

/** Ítem 7.1.3 — Matriz de plan de acción / seguimiento de ACPM de investigaciones (versionable + dashboard + PDF firmado). */
class AcpmInvestigationMatrixAPI {

  async catalog() {
    const response = await http(`${API_URL}/catalog`, 'GET')
    return response || null
  }

  async getAll(companyId, page = 1) {
    const response = await http(`${API_URL}/company/${companyId}?page=${page}`, 'GET')
    return response || null
  }

  async get(id) {
    const response = await http(`${API_URL}/${id}`, 'GET')
    return response || null
  }

  async save(data) {
    return await http(`${API_URL}/save`, 'POST', data)
  }

  async update(id, data) {
    return await http(`${API_URL}/update/${id}`, 'PUT', data)
  }

  async delete(id) {
    return await http(`${API_URL}/delete/${id}`, 'DELETE')
  }

  async cloneVersion(id, data = {}) {
    return await http(`${API_URL}/${id}/clone`, 'POST', data)
  }

  pdfUrl(id) {
    return url(`${API_URL}/${id}/pdf`)
  }

  async sign(id, payload) {
    return await http(`${API_URL}/${id}/sign`, 'POST', payload)
  }

  async status(id) {
    return await http(`${API_URL}/${id}/status`, 'GET')
  }
}

export default new AcpmInvestigationMatrixAPI()
